import type { JSX } from "react";
import type { GameUserDto } from "../api/types";

interface AdminUsersPanelProps {
  users: readonly GameUserDto[];
  isBusy: boolean;
  onSetRole: (userId: string, role: GameUserDto["role"]) => Promise<void>;
}

/**
 * Lets an administrator change locally stored application roles.
 */
export function AdminUsersPanel({
  users,
  isBusy,
  onSetRole,
}: AdminUsersPanelProps): JSX.Element {
  return (
    <section className="review-card users-panel">
      <h2>Tilganger</h2>
      <p>Roller lagres i spillet. Visma Connect brukes bare til innlogging.</p>
      {users.length === 0 && <p>Ingen brukere er registrert ennå. Logg inn én gang for å bli seedet som admin.</p>}
      <ul className="user-list">
        {users.map((user) => (
          <li key={user.id}>
            <span>{user.email ?? user.id}</span>
            <label>
              Rolle
              <select
                aria-label={`Rolle for ${user.email ?? user.id}`}
                value={user.role}
                disabled={isBusy}
                onChange={(event) => {
                  const value = event.target.value;
                  if (value !== "Player" && value !== "LegalGameAdmin")
                    return;
                  void onSetRole(user.id, value);
                }}
              >
                <option value="Player">Spiller</option>
                <option value="LegalGameAdmin">Admin</option>
              </select>
            </label>
          </li>
        ))}
      </ul>
    </section>
  );
}
